import { MenuItem, Stack, TextField, Tooltip, Typography } from '@mui/material'
import algo from '../../../core/Algo'
import { IFlow, INode, NodeType } from '../../../definitions/Nodes'
import { IAcceptedData } from '../../../definitions/NodesDescription'
import NodeManager from '../../../managers/NodeManager'
import { InfoRounded } from '@mui/icons-material'

interface P {
    acceptedData: IAcceptedData<NodeType>
    type: 'multiline' | 'number' | 'string'
    selectedNode: INode<NodeType>
    setSelected: (node: INode) => void
    disable: boolean
    flow: IFlow
}

const renderTooltip = (title: string, disable: boolean) => (
    <Tooltip arrow title={title} disableHoverListener={disable}>
        <InfoRounded sx={{ cursor: disable ? undefined : 'pointer', color: disable ? 'var(--icon-disabled)' : 'var(--icon-color)' }} />
    </Tooltip>
)

function NodeTextEditor({ selectedNode, acceptedData, type, setSelected, disable, flow }: P) {
    const value = selectedNode.data[acceptedData.parameter]
    const shapes = NodeManager.getInputShapes(selectedNode, flow.nodes) ?? null
    const matchedShape = NodeManager.findShape(shapes, acceptedData.sourceHandle ? acceptedData.sourceHandle[0] : '')
    const mappedShapes = NodeManager.getMappedShapes(matchedShape)

    return (
        <Stack spacing={2}>
            <Stack flexDirection='row' gap={1}>
                {renderTooltip(acceptedData?.tooltipContent, disable)}
                <Typography variant='subtitle2'>{acceptedData?.header ?? null}</Typography>
            </Stack>
            <TextField
                InputLabelProps={{ shrink: false }}
                size='small'
                select={Object.keys(mappedShapes).length !== 0}
                disabled={disable}
                minRows={type === 'multiline' ? 5 : 1}
                maxRows={type === 'multiline' ? 10 : 5}
                type={type === 'number' ? 'number' : undefined}
                error={acceptedData.isRequired && !algo.hasVal(value)}
                value={value ?? ''}
                fullWidth
                multiline={type !== 'number'}
                onChange={e => {
                    const newValue = e.target.value
                    setSelected({ ...selectedNode, data: { ...selectedNode.data, [acceptedData.parameter]: newValue } })
                }}>
                {matchedShape && shapes?.[0]?.shape && mappedShapes.map(option => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </TextField>
        </Stack>
    )
}

export default NodeTextEditor
